<template>
  <Card
    :padding="false"
  >
    <template slot="header"> Vehicles </template>
    <v-data-table
      :headers="headers"
      :items="vehicles"
      class="elevation-1"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>{{ props.item.vehicleMake }} {{ props.item.vehicleModel }}</td>
        <td>{{ props.item.vehicleState }}|{{ props.item.vehicleLicensePlate }}</td>
      </template>
    </v-data-table>
  </Card>
</template>

<script>
// user/vehicles?

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      headers: [
        {
          text: 'Vehicle',
          sortable: false,
          value: 'vehicleMake'
        },
        {
          text: 'State|License Plate',
          sortable: false,
          value: 'vehicleLicensePlate'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      vehicles: 'vehicles/vehicles'
    })
  },
  mounted () {
    this.getVehicles()
  },
  methods: {
    ...mapActions({
      getVehicles: 'vehicles/getVehicles'
    })
  }
}
</script>
